import { SectionsImageParallax, SectionProps } from "@/types";

import { imageParallaxVariant } from "./image-parallax.variants";
import { useRef } from "react";

export type UseImageParallaxProps = SectionProps<SectionsImageParallax>;

export const useImageParallax = (props: UseImageParallaxProps) => {
  const { data, sectionName } = props;
  const containerRef = useRef(null);

  const styles = imageParallaxVariant();

  return {
    styles,
    data,
    containerRef,
    sectionName,
  };
};
